import { INFO_CARD_TYPE } from "@/features/cards/shared/card-routing/card-types";
import { persistentCardTypes } from "@/features/cards/shared/card-routing/card-config";

import { AddDeviceGlobalState } from "./add-device-global-state";

/** Whether opening a map-entity card should be blocked by the current legacy card. */
export function shouldBlockMapEntityCardOpen(cardType?: INFO_CARD_TYPE): boolean {
    if (!cardType) {
        return false;
    }
    // only block if the add device flow is not on its final step
    if (cardType === INFO_CARD_TYPE.ADD_DEVICE) {
        return !AddDeviceGlobalState.isOnFinalStep;
    }
    return persistentCardTypes.includes(cardType);
}
